import { CheckCircle2 } from "lucide-react";

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text content */}
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A8A] mb-4">
              About Trademark Officers
            </span>
            <h2
              data-testid="about-heading"
              className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A] tracking-tight mb-6"
            >
              Your Dedicated Partner for US Trademark Registration
            </h2>
            <p className="text-[#475569] leading-relaxed mb-6">
              Trademark Officers is a premier legal services firm dedicated exclusively to trademark registration in the United States. With years of experience navigating the complexities of the United States Patent and Trademark Office (USPTO), our team of seasoned trademark professionals has built a reputation for delivering reliable, efficient, and cost-effective trademark filing services to businesses of all sizes.
            </p>
            <p className="text-[#475569] leading-relaxed mb-6">
              We understand that your brand is one of your most valuable business assets. That is why we have made it our sole mission to help entrepreneurs, startups, small businesses, and established corporations secure their intellectual property rights through comprehensive trademark registration. From conducting thorough trademark searches to filing your application and monitoring your mark post-registration, we handle every step of the process with meticulous attention to detail.
            </p>
            <p className="text-[#475569] leading-relaxed mb-8">
              Our firm is built on the principles of transparency, integrity, and client-first service. We offer flat-fee pricing with no hidden costs, ensuring you know exactly what to expect when you partner with us. Whether you are launching a new product line, expanding into new markets, or simply looking to formalize your brand protection, Trademark Officers is here to guide you through the entire USPTO trademark registration process from start to finish.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                "Exclusively focused on US Trademarks",
                "Flat-fee, transparent pricing",
                "Experienced USPTO filing team",
                "Dedicated case managers",
                "Post-registration monitoring",
                "Comprehensive search reports",
              ].map((item) => (
                <div key={item} className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-[#1E3A8A] shrink-0" />
                  <span className="text-sm text-[#0F172A] font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://images.pexels.com/photos/7433840/pexels-photo-7433840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Trademark Officers professional team reviewing trademark registration documents"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-4 sm:-left-6 bg-[#1E3A8A] text-white px-6 py-4 rounded-lg shadow-lg">
              <div className="font-heading text-2xl font-extrabold">1000+</div>
              <div className="text-blue-200 text-xs font-medium">Trademarks Successfully Filed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
